import React from 'react';

import FinaliseDialogue from 'sharedComponents/LoginDialogue/FinaliseDialogue';
import { Theme } from 'helpers/theme';
import environment from 'api/environment';
import { createUseStyles, useTheme } from 'react-jss';
import { commitMutation, graphql } from 'react-relay';
import { GraphError } from 'types/general';
import { Router, useRouter } from 'found';
import jwt from 'jsonwebtoken';

type Props = {
  data: any;
};

const useStyles = createUseStyles((theme: Theme) => ({
  root: {
    background: theme.loginBackgroundGradient,
    width: '100%',
    height: '100%',
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

const mutation = graphql`
  mutation ResetPassword_FinaliseMutation($token: String!, $password: String!) {
    resetPassword(input: { token: $token, password: $password }) {
      token
    }
  }
`;

const AttemptReset = (router: Router, token: String) => (
  password: string,
  passwordRepeat: string,
  errorCallback: (err: string) => void
) => {
  const variables = {
    token,
    password
  };

  if (!password || !passwordRepeat) {
    return errorCallback('Please enter password twice');
  }
  if (password !== passwordRepeat) {
    return errorCallback('Passwords are not the same');
  }
  errorCallback('');

  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: (
      response: { resetPassword: boolean },
      errors: GraphError[]
    ) => {
      if (errors) {
        // Display error
        errorCallback(`${errors[0]?.extensions?.message}`);
        return;
      }
      console.log('Response received from server.', response, errors);
      router.push('/app');
    },
    onError: (err) => console.error(err)
  });
};

const ResetPassword = ({ data }: Props) => {
  const theme = useTheme();
  const classes = useStyles({ theme });
  const { router, match } = useRouter();
  const { token } = match?.params;
  const decoded = jwt.decode(token, { json: true });
  const { Email } = decoded ? decoded.claims : { Email: 'Invalid TTC ID' };

  return (
    <>
      {/* <RedirectRequest/> */}
      <div className={classes.root}>
        <FinaliseDialogue
          title="Change password"
          email={Email}
          onSubmit={AttemptReset(router, token)}
        />
      </div>
    </>
  );
};

export default ResetPassword;
